export function getBuiltAttributes(
  extraData,
  recordBody
) {
  Object.keys(extraData).forEach(key => {
    if (key in recordBody.attributes) recordBody.attributes[key] = extraData[key]
  })
  return recordBody
}
